import { ReactNode } from "react"

export const LinkIcon = () => <i className="fa-solid fa-arrow-up-right-from-square" />

export type ChildrenProps = {
	children?: ReactNode
}